export function siteDisplayNameRenderer(params: SiteDisplayNameParams) {
    return [params.siteNumber, params.investigatorFullName].filter(i => !!i).join(' - ');
}

interface SiteDisplayNameParams {
    siteNumber: string;
    investigatorFullName: string;
}
